type ActionType = {
  type?: string;
  payload?: any;
};

const initState = {
  user: "New User",
};

const userReducer = (state = initState, action: ActionType) => {
  switch (action.type) {
    case "CHANGE_USER": {
      return {
        ...state,
        user: action.payload,
      };
    }
  }

  return state;
};

export default userReducer;
